import fetch from 'isomorphic-fetch';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon } from '@codex/icons';

import ProductPageSpecificationTabContent from './ProductPageSpecificationTabContent/ProductPageSpecificationTabContent';


const SpinnerIconWrapper = styled.div`
  text-align: center;
`;

const ErrorMessage = styled.div`
  color: red;
`;

const ProductPageSpecificationTab = ({ fetchProductDataURL }) => {
  const [productData, setProductData] = useState(null);
  const [errorLoadingData, setErrorLoadingData] = useState(false);

  useEffect(() => {
    if (!productData && !errorLoadingData) {

      // useEffect doesn't support try/catch if effect function is async
      // so new async function needs to be created
      const fetchProductData = async () => {
        try {
          const productDataResponse =
            await fetch(fetchProductDataURL);
          const responseJSON = await productDataResponse.json();
          setProductData(responseJSON.payload);
        } catch (e) {
          console.error('Following error occured during loading data for specification tab: ');
          console.error(e.message);
          setErrorLoadingData(true);
        }
      };

      fetchProductData();
    }
  }, [productData, errorLoadingData]);

  return (
    <>
      {/* data correctly loaded */}
      {(!errorLoadingData && productData !== null) && (
      <ProductPageSpecificationTabContent
        headerLabel={window.specificationTabHeaderLabel || 'Product Specification'}
        tablesData={productData}
      />
      )}
      
      {/* Product data loading in progress */}
      {!errorLoadingData && productData === null && (
        <SpinnerIconWrapper>
          <Icon
            icon={'Spinner'}
            spin
            size={'large'}
          />
        </SpinnerIconWrapper>
      )}
      
      {/* Error occurred during loading product data */}
      {
        errorLoadingData && (
          <ErrorMessage>Error occurred during loading the content of the specification tab</ErrorMessage>
        )
      }
    </>
  );

};

ProductPageSpecificationTab.propTypes = {
  fetchProductDataURL: PropTypes.string.isRequired
};

export default ProductPageSpecificationTab;
